export const sanitizeSlug = (slug) => {
  return slug
    ?.toString()
    .toLowerCase()
    .replace(/[^\w]+/g, "-");
};
